// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Core Components
import Icon from './icon';

// Contexts
import {AccordionContext} from '../../contexts/accordion-context';

// Styles
import './accordion-button.scss';

export default class AccordionButton extends Component {
    getClass() {
        const {className, iconPosition = 'right'} = this.props;
        const {isExpanded} = this.context;

        return classnames(
            {
                'accordion-button': true,
                'accordion-button_expanded': isExpanded(),
                'accordion-button_icon-right': iconPosition === 'right',
                'accordion-button_icon-left': iconPosition === 'left',
            },
            className
        );
    }

    renderChildren() {
        const {children} = this.props;
        let content = null;

        if (children) {
            content = <span className="accordion-button--content">{children}</span>;
        }

        return content;
    }

    renderIcon(type) {
        const {iconPosition = 'right', icon = 'chevron-circle-right'} = this.props;
        let content = null;

        if (type === iconPosition) {
            content = <Icon className="accordion-button--icon" fontType="fa" iconName={icon} />;
        }

        return content;
    }

    render() {
        const {togglePanel} = this.context;

        return (
            <button className={this.getClass()} onClick={togglePanel}>
                {this.renderIcon('left')}
                {this.renderChildren()}
                {this.renderIcon('right')}
            </button>
        );
    }
}

AccordionButton.contextType = AccordionContext;

AccordionButton.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    icon: PropTypes.string,
    iconPosition: PropTypes.oneOf(['left', 'right']),
};
